import {
    AfterViewInit,
    Component,
    ElementRef,
    Injectable,
    ViewChild,
    inject,
} from '@angular/core';

import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogRef
} from '@angular/material/dialog';

import {
    BaseDialogService,
    NonNullableConfigData,
    TilbyDialogContentComponent,
    TilbyDialogToolbarComponent,
} from '@tilby/tilby-ui-lib/components/tilby-dialog';

import {
    CommonModule
} from '@angular/common';

import {
    lastValueFrom
} from 'rxjs';

import {
    TranslateModule
} from '@ngx-translate/core';

type NonFiscalPreviewInput = {
    printerName?: string
    htmlContent: string
}

@Component({
    selector: 'app-non-fiscal-preview-dialog',
    templateUrl: './non-fiscal-preview-dialog.component.html',
    styleUrls: ['./non-fiscal-preview-dialog.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        TilbyDialogContentComponent,
        TilbyDialogToolbarComponent,
        TranslateModule
    ]
})
class NonFiscalPreviewDialog implements AfterViewInit {
    private readonly dialogRef = inject(MatDialogRef);
    protected readonly data = inject(MAT_DIALOG_DATA) as NonFiscalPreviewInput;

    @ViewChild('contentPreview') contentPreview?: ElementRef;

    ngAfterViewInit(): void {
        const domParser = new DOMParser();
        const doc = domParser.parseFromString(this.data.htmlContent, 'text/html');
        const content = doc.getElementsByTagName('body')[0]?.children[0];

        if(content) {
            this.contentPreview?.nativeElement.appendChild(content);
        }
    }

    cancel() {
        this.dialogRef.close()
    }

    confirm() {
        this.dialogRef.close(true);
    }
}

@Injectable({
    providedIn: "root",
})
export class NonFiscalPreviewDialogService extends BaseDialogService {
    private readonly dialogRef = inject(MatDialog);

    public openDialog(config: NonNullableConfigData<NonFiscalPreviewInput>): Promise<boolean> {
        const dialogConfig: NonNullableConfigData<NonFiscalPreviewInput> = {
            ...this.switchMobileDesktopDimensions({ height: 'fit-content' }),
            panelClass: 'no-padding-dialog-container',
            disableClose: true,
            data: config.data
        };

        return lastValueFrom(
            this.dialogRef.open(NonFiscalPreviewDialog, dialogConfig).afterClosed()
        ).then(val => !!val);
    }
}